<template>
	<div class="leftBlock">

      <el-link disabled style="margin: 10px 0;">{{$t("nav.type1")}}</el-link>
			<ul>
				<li v-on:click="showChannel('performanceTab')" :class="activeIndex == 'performanceTab' ? 'on':''" class="performanceTab">{{$t("nav.performanceTab")}}</li>
        <li v-on:click="showChannel('advancedTab')" :class="activeIndex == 'advancedTab' ? 'on':''" class="advancedTab">{{$t("nav.advancedTab")}}</li>
				<li v-on:click="showChannel('journeyTab')" :class="activeIndex == 'journeyTab' ? 'on':''" class="journeyTab">{{$t("nav.journeyTab")}}</li>
        <li v-on:click="showChannel('changeShaftTab')" :class="activeIndex == 'changeShaftTab' ? 'on':''" class="changeShaftTab">{{$t("nav.changeShaftTab")}}</li>
			</ul>

      <el-link disabled style="margin: 10px 0;">{{$t("nav.type2")}}</el-link>
			<ul>
        <li v-on:click="showChannel('buttonTab')" :class="activeIndex == 'buttonTab' ? 'on':''" class="buttonTab">{{$t("nav.buttonTab")}}</li>
        <li v-on:click="showChannel('fnTab')" :class="activeIndex == 'fnTab' ? 'on':''" class="fnTab">{{$t("nav.FNTab")}}</li>
				<li v-on:click="showChannel('ligthTab')" :class="activeIndex == 'ligthTab' ? 'on':''" class="ligthTab">{{$t("nav.ligthTab")}}</li>
				<li v-on:click="showChannel('otherTab')" :class="activeIndex == 'otherTab' ? 'on':''" class="otherTab">{{$t("nav.otherTab")}}</li>

        <li v-on:click="showChannel('aboutTab')" :class="activeIndex == 'aboutTab' ? 'on':''" class="aboutTab">{{$t("nav.aboutTab")}}</li>
			</ul>

      <!-- <el-link disabled style="margin: 10px 0;">{{$t("nav.type3")}}</el-link>
			<ul>
				<li v-on:click="showChannel('shareGameTab')" :class="activeIndex == 'shareGameTab' ? 'on':''" class="shareGameTab">{{$t("nav.shareGameTab")}}</li>
			</ul> -->
	</div>
</template>
<script>
export default {
  name: 'nav',
  data() {
    return {
		activeIndex: "performanceTab",
    }
  },
  updated: function () {

		
  },
  mounted:function()
  {
    //读取设备重置标志
    setTimeout(()=>{this.showRestTag()},4000);
    
  },
  methods:
  {
      //读取设备重置标志
      showRestTag()
      {
        let restDeviceTag = localStorage.getItem("restDeviceTag");
        if(restDeviceTag)
        {
          this.$confirm(this.$i18n.t("msg.confirmInfoRestDeviceJourney"), this.$i18n.t("msg.confirmTitRest"), 
          {
            confirmButtonText: this.$i18n.t("msg.confirmOKRestDeviceJourney"),
            cancelButtonText: this.$i18n.t("msg.confirmNoRest"),
            type: 'warning'
          }).then(() => 
          {
            localStorage.removeItem("restDeviceTag");
            this.showChannel('journeyTab');

          }).catch(() => {});
        }
      },
      async showChannel(name)
      {
        this.activeIndex = name;
        this.$emit('child-event',name);
      },
  }
}
</script>